import { extendTheme } from "@chakra-ui/react";
import { globalStyles, designSystemColors } from "./styles";
import { breakpoints } from "./foundations/breakpoints";
import { buttonStyles } from "./components/button";
import { badgeStyles } from "./components/badge";
import { linkStyles } from "./components/link";

export default extendTheme({
  initialColorMode: "dark",
  useSystemColorMode: false,
  colors: {
    ...designSystemColors,
    brand: designSystemColors.primary,
  },
  fonts: {
    heading: `'Montserrat', sans-serif`,
    body: `'Roboto', sans-serif`,
  },
  ...breakpoints,
  globalStyles,
  buttonStyles,
  badgeStyles,
  linkStyles,
});
